export enum LocalStorageKey {
  AccessToken = 'access-token',
  TenantKey = 'tenant-key',
  Locale = 'locale',
  HomepageSettings = 'homepage-settings',
  SavedFilters = 'saved-filters',
}
